import { useTranslation } from 'react-i18next';
import { FilterChips, FilterType } from 'src/components/molecules/filter-chips';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { Filters } from 'src/types/interfaces/filters';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
}

export const StatisticsFilterChips = ({
  filters,
  handleChangeFilterValue,
}: Props) => {
  const { t } = useTranslation(['statistics', 'common']);

  const filterTypes: FilterType[] = [
    {
      value: 'floors',
      text: value => t('statistics:common.floor') + ': ' + value,
    },
  ];

  const filtersCopy = { floors: { ...(filters?.floors || {}) } };

  return (
    <FilterChips
      filters={filtersCopy}
      handleChangeFilterValue={handleChangeFilterValue}
      filterTypes={filterTypes}
    />
  );
};
